export default {"src":"/_next/static/media/moneyInCircle.9808546b.svg","height":100,"width":100};